export default "__VITE_ASSET__oqX0I54W__"